import React, { ReactNode } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { twMerge } from 'tailwind-merge';

export enum TriggerType {
  HOVER = 'hover',
  CLICK = 'click',
}

// Define the props for the TooltipWrapper component
interface TooltipWrapperProps {
  children: ReactNode;
  content: React.ReactNode;
  triggerType?: TriggerType;
  fullDimensions?: boolean;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  children,
  content,
  triggerType = TriggerType.HOVER,
  fullDimensions = true,
}) => {
  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          {triggerType === TriggerType.CLICK ? (
            <div onClick={() => {}}>{children}</div>
          ) : (
            <div className={twMerge(fullDimensions && 'h-full w-full')}>{children}</div>
          )}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="TooltipContent rounded-[0.5em] border border-ph-white-10 px-3 py-2 font-manrope text-sm"
            sideOffset={5}
          >
            {content}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default TooltipWrapper;
